import type { SidebarDestination } from '@alison/ui';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { useAuthenticatedSession } from '../lib/useAuthenticatedSession.js';
import { useShellAccount } from '../lib/useShellAccount.js';
import { AppShell } from './AppShell.js';

export function ComingSoonPage({ destination }: { destination: SidebarDestination }): ReactNode {
  const { session, isPending, onSignOut } = useAuthenticatedSession();
  const account = useShellAccount(session?.user.email);

  if (isPending || session === null) {
    return (
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AppShell active={destination} account={account} onLogout={() => void onSignOut()}>
      <Paper elevation={0} sx={{ p: 4, border: '1px solid', borderColor: 'divider' }}>
        <Typography color="text.secondary">This page is coming soon.</Typography>
      </Paper>
    </AppShell>
  );
}
